import React from 'react';
import { PurityTest } from './components/PurityTest';
export function App() {
  return <div className="min-h-screen w-full bg-[#F5F1E8] text-[#2C2416]" data-id="element-0">
      <style data-id="element-1">{`
        @import url('https://fonts.googleapis.com/css2?family=Crimson+Text:ital,wght@0,400;0,600;0,700;1,400;1,600&family=Playfair+Display:wght@400;700;900&family=UnifrakturMaguntia&display=swap');
        
        body {
          background-color: #F5F1E8;
          background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100' height='100' filter='url(%23noise)' opacity='0.05'/%3E%3C/svg%3E");
        }
      `}</style>

      <PurityTest data-id="element-2" />

      <footer className="text-center py-8 text-[#2C2416]/60 text-sm font-serif" data-id="element-3">
        Inspired by the Rice Purity Test
      </footer>
    </div>;
}